import { Theme } from '@mui/material/styles';
import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(({
  fontFamilies,
  fontSizes,
  fontWeights,
}: Theme) => ({
  filtersTypeTitle: {
    margin: '0 0 0.75rem',
    fontFamily: fontFamilies.primary,
    fontSize: fontSizes.lg,
    fontWeight: fontWeights.medium,
    lineHeight: 1.4,
    '&:nth-of-type(2)': {
      marginTop: '0.5rem',
    },
  },
  buttonStyles: {
    padding: '0.625rem 0.75rem',
    fontSize: '0.875rem',
    lineHeight: 1.3,
  },
}));
